//@flow
import React from 'react';
import { Container } from 'flux/utils';
import ModalStore from '../../Stores/Modals/modalStore';
import ModalActions from '../../Actions/modal';
import BaseModal from './BaseModal.react';

type State = {
  isOpen:boolean,
  modalData:{},
};

export type ModalProps = {
  close:() => void,
};

type Options = {
  name:string,
  className:string,
  overlay?:string,
  close?:(props:any) => void,
  defaultOpen?:boolean,
};

export default function standardModal<P:{}>(
  ModalContent:React$ComponentType<ModalProps&P>,
  options:Options):React$ComponentType<P> {

  class StandardModal extends React.Component<P, State> {
    static WrappedComponent = ModalContent;
    static displayName = `standardModal(${ModalContent.displayName || ModalContent.name || ''})`;

    static getStores() {
      return [
        ModalStore,
      ];
    }

    static calculateState():State {
      return {
        isOpen: ModalStore.isOpen(options.name, options.defaultOpen),
        modalData: ModalStore.getModalData(options.name),
      };
    }

    _closeModal = () => {
      ModalActions.closeModal(options.name);
      options.close && options.close(this.props);
    };

    render() {
      if (!this.state || !this.state.isOpen) return null;

      return (
        <BaseModal
          className={options.className}
          isOpen={this.state.isOpen}
          closeModal={this._closeModal}
          overlay={options.overlay}
        >
          <ModalContent
            {...this.props}
            {...this.state.modalData}
            close={this._closeModal}
          />
        </BaseModal>
      );
    }
  }

  return Container.create(StandardModal);
}
